import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { StripeBankAccountStatus } from '@umss/shared/data-access';
import { BadgeVariant } from '@umss/shared/utils';
import { UmssBadgeComponent } from '../badge/badge.component';

interface StripeBadgeProps {
  label: string;
  variant: BadgeVariant;
}

const STRIPE_STATUS_BADGE_PROPS: Record<
  StripeBankAccountStatus,
  StripeBadgeProps
> = {
  [StripeBankAccountStatus.Verified]: { label: 'Verified', variant: 'success' },
  [StripeBankAccountStatus.Validated]: {
    label: 'Awaiting micro-deposit confirmation',
    variant: 'warning'
  },
  [StripeBankAccountStatus.New]: { label: 'Linked to Stripe', variant: 'info' },
  [StripeBankAccountStatus.Errored]: {
    label: 'Verification failed',
    variant: 'error'
  }
};

const NULL_BADGE_PROPS: StripeBadgeProps = {
  label: 'Not linked',
  variant: 'neutral'
};

@Component({
  selector: 'umss-stripe-bank-account-status-badge',
  standalone: true,
  imports: [UmssBadgeComponent],
  template: `
    @if (badgeProps) {
      <umss-badge
        [variant]="badgeProps.variant"
        [label]="badgeProps.label"
        [size]="size"
      />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UmssStripeBankAccountStatusBadgeComponent {
  @Input() size: 'small' | 'medium' | 'large' = 'medium';

  @Input({ required: true }) set status(value: StripeBankAccountStatus | null) {
    this.badgeProps =
      value === null
        ? NULL_BADGE_PROPS
        : (STRIPE_STATUS_BADGE_PROPS[value] ?? NULL_BADGE_PROPS);
  }

  badgeProps: StripeBadgeProps | undefined;
}
